import { httpsCallable } from "firebase/functions";
import { auth } from "../../../firebase";
import store from "../../../redux/store";

const hasScope = (value) => value && typeof value === "object" &&
  ["tenantId", "company", "collectionBrand"].some((key) => value[key] != null);

export function withHeroAiTenantScope(payload, heroUser, currentUid) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return payload;
  // Preserve explicit scope for the server to validate, including conflicts.
  const levels = [payload, payload.data];
  if (levels.some((level) => level && (level.tenant != null || hasScope(level)))) {
    return payload;
  }
  if (!currentUid || heroUser?.uid !== currentUid ||
      typeof heroUser.company !== "string" || !heroUser.company.trim() ||
      typeof heroUser.collectionBrand !== "string" || !heroUser.collectionBrand.trim()) {
    // A missing/stale view must not guess a tenant. The server can resolve its
    // authenticated default-tenant bridge or refuse the request normally.
    return payload;
  }
  return {
    ...payload,
    tenant: {
      company: heroUser.company,
      collectionBrand: heroUser.collectionBrand,
    },
  };
}

export function heroAiCallable(functions, name, options) {
  const callable = httpsCallable(functions, name, options);
  // Resolve at invocation, not render: cached callables and UPRA retries must
  // not reuse another signed-in user's Redux scope. Membership stays server-owned.
  return (payload) => {
    // Shared forms and assessment cards also appear outside Hero. A same-UID
    // Hero profile left in Redux is not that other product's billing context.
    const inHero = typeof window !== "undefined" &&
      /^\/hero-dashboard(?:\/|$)/.test(window.location.pathname);
    return callable(inHero ? withHeroAiTenantScope(
      payload, store.getState()?.heroUser, auth.currentUser?.uid,
    ) : payload);
  };
}
